/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Planning_Rooster_Keer_Per_WeekInputs */

const nl_planning_rooster_keer_per_week = /** @type {(inputs: Planning_Rooster_Keer_Per_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}× per week`)
};

/**

* @param {Planning_Rooster_Keer_Per_WeekInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_keer_per_week = /** @type {((inputs: Planning_Rooster_Keer_Per_WeekInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Keer_Per_WeekInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_keer_per_week(inputs)
});
export { planning_rooster_keer_per_week as "planning.rooster.keer_per_week" }